import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/exclamation-circle-critical.svg")